import { ModalCloseSVG } from 'assets/svg/ModalSVG/ModalCloseSVG'
import React, { useEffect } from 'react'
import congratsBanner from 'assets/images/eventBoatRacing/congratsBanner.png'
import starCircle from 'assets/images/login-starcircle.svg'
import { Button, Container, Modal } from 'react-bootstrap'

function BaseModal({
	show,
	onHide,
	onShow,
	hideDecor,
	penalty = false,
	congrats = false,
	spinResult = false,
	children,
	...otherProps
}) {
	return (
		<Modal
			show={show}
			onHide={onHide}
			className={`modal-base-prize ${penalty ? 'penalty' : ''} ${
				spinResult ? 'spin-result' : ''
			}`}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
			backdrop={true}
			{...otherProps}
		>
			<Container className="baseinput-container" fluid>
				{congrats && (
					<Modal.Header className="py-0">
						{congrats ? (
							<img src={congratsBanner} alt="Congratulations" />
						) : null}
					</Modal.Header>
				)}
				{children}
			</Container>
			{hideDecor ? null : (
				<img src={starCircle} width="166" alt="" className="circle1" />
			)}
			<Button variant="light" onClick={onHide} className="btn-close">
				<ModalCloseSVG width="32" height="32" viewBox="0 0 32 32" />
			</Button>
		</Modal>
	)
}

export default BaseModal
